import { FLAG } from '../../feature-flags';

export default ({ building, activeSlug, isWhatsappCta, whatsappUrl, epcWhatsappFromTwo, codePhones, orientations, buildingBadges }) => ({
    building: building,
    buildingBadges: buildingBadges ?? [],
    tabs: building.available_typologies_tabs,
    allGroupedUnits: {},
    originalGroupedUnits: JSON.parse(JSON.stringify(building.units_grouped ?? {})), // Copia profunda de unidades agrupadas
    activeTab: activeSlug,
    currentGroups: {},
    units: building.units,
    currentModels: {},
    processedModels: [], // Nuevo: modelos con información procesada
    typologyOrder: [
        'estudio',
        '1-dormitorio',
        '2-dormitorios',
        '3-dormitorios',
        '4-o-mas-dormitorios',
    ], 
    labels: {
        'estudio': 'estudio',
        '1-dormitorio': '1 dormitorio',
        '2-dormitorios': '2 dormitorios',
        '3-dormitorios': '3 dormitorios',
        '4-o-mas-dormitorios': '4+ dormitorios',
    },
    openDrawerUnits: false,
    openDrawerMultifamily: false,
    openDrawerAvailable: false,
    openDrawerUnitNotFound: false,
    notFoundUnitData: null, // Datos para el drawer de unidad no encontrada
    selectedUnit: null,
    selectedModel: null,
    bottomHeight: 0,  
    sheetExpanded: false, // bottom sheet del calendario en mobile (colapsado por defecto)
    orientationsMap: orientations,
    step: 'list',
    history: [],
    openModalGallery: false,
    tabSelectedGallery: 'fotos',
    isLoadingUnits: false, // Loading logic for units drawer
    isLoadingModels: false, // Loading logic for OD models
    isLoadingUnitDetail: false, // Nueva propiedad para skeleton de detalle
    isNavigating: false, // Nueva propiedad para indicar navegación en progreso
    navigationDirection: 'forward', // Nueva propiedad para la dirección de navegación
    showModalShare: false,
    copyDone: false,
    tabSelected:'fotos',
    // Quote logic
    quote: null,
    apiUrl: import.meta.env.VITE_API_URL,
    isLoadingQuote: false,
    quoteParams: {
        unit_id: null,
        want_parking: false,
        want_store: false,
        want_pet: false,
        dicom_amount: 2,
        start_date: (() => {
            const today = new Date();
            const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
            return nextMonth.toISOString().slice(0, 10);
        })(),
        warranty_type: 0
    },
    // Filtros aplicados desde la URL
    appliedFilters: {
        bedrooms: [],
        bathrooms: [],
        min_price: null,
        max_price: null
    },

    //Notify me
    email: '',
    errorMessage:'',
    loading_notify:false,
    toast: {
        show: false,
        message: '',
        type: 'success',
    },
    notified:false,
    modelNoAvailable: null,
    email_model_no_available: '',
    errorMessageNoAvailable:'',
    isWhatsappCta: isWhatsappCta,
    whatsappUrl: whatsappUrl,
    epcWhatsappFromTwo: epcWhatsappFromTwo,
    // A/B test: variante del botón QQMC. Empieza en CONTROL hasta que PostHog confirme.
    ctaBotonQqmcVariant: FLAG.AB_TEST_BOTON_QQMC.CONTROL,
    // A/B test: variante del flujo de agenda. Empieza en CONTROL hasta que PostHog confirme.
    calendarExperimentVariant: FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA.CONTROL,
    // Bandera de deduplicación para visit_scheduling:experiment_exposure — una vez que disparamos, no volver a disparar.
    _experimentExposureFired: false,
    showContactMeModal: false,
    formDataContactme: {
        name: '',
        last_name: '',
        email: '', 
        code_phone: '56',
        phone: '',
        reason:'',
        refer_code: '',
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_content: '',
        utm_term: '',
        fbclid: '',
        gclid: '',
        terms: false
    },
    errors: {
        name: '',
        last_name: '',
        rut: '',
        email: '',
        phone: '',
        terms: '',
        reason: '',
    },
    sendingContactForm: false,

    // ============================================================
    // Visitor form — pasos visitor_form / schedule_* del drawer
    // ============================================================
    form: {
        name: '',
        rut: '',
        email: '',
        phone: '',
        code_phone: '56',
        terms: false,
        movingTimeline: null,
    },
    // Estado + lógica del date-picker / time-slots (selectedDate, selectedTime, timeFilter,
    // dpDays(), filteredTimeSlots(), fetchAvailableTimeSlots(), loadMoreDays(), reloadTimeSlots()...).
    // timeSlotsMixin() se define en partials/time-slots-mixin-script.blade.php, incluido en building.blade.php.
    ...(globalThis.timeSlotsMixin?.() ?? {}),
    // Segunda instancia aislada para el calendario interno del schedule_visit.
    // Estado independiente del calendario externo: selectedDate, selectedTime, _availableByDate, etc.
    scheduleVisitCalendar: globalThis.timeSlotsMixin?.() ?? {},
    profileForm: {
        movingTimeline: null,
        hasGuarantor: null,
        hasIncome:    null,
    },
    visitorFormMode: 'schedule', // 'schedule' | 'interest'
    showMovingTimeline: true,
    similarBuildings: [],
    similarBuildingsIndex: 0,
    _sbTransition: true,
    reqOpen: false,
    sending: false,
    leadId: null, // ID del lead creado en submitVisitorForm, necesario para schedule
    brokerId: null,
    codePhones: codePhones,
    hasBroker: false,
    loading_form_contactme: false,
    confirmingSlot: false,
    showInlineCalendar: false,
    mobileAgendaSheetOpen: false,
    _calendarSlotsPromise: null,

    /**
     * Helper idempotente para disparar visit_scheduling:experiment_exposure.
     * Se invoca desde tres puntos del lifecycle donde la unidad puede convertirse
     * en disponible en distinto orden (onReady, fetchModels().then, checkUrlForUnit).
     * Solo dispara una vez por sesión de página.
     */
    trackExperimentExposureIfEligible() {
        if (this._experimentExposureFired) {
            return true;
        }

        if (!this.calendarExperimentVariant) {
            return false;
        }

        const unit = this.selectedUnit ?? this.cheapestUnitInTab;

        if (!unit?.is_visitable) {
            return false;
        }

        const analytics = globalThis.assetplanAnalytics?.for('sitio_web');

        if (!analytics) {
            return false;
        }

        analytics.track('visit_scheduling:experiment_exposure', {
            experiment: 'ab-test-nuevo-flujo-de-agenda',
            variant: this.calendarExperimentVariant,
            surface: 'building',
        });

        this._experimentExposureFired = true;

        return true;
    },

    /**
     * Loads inline calendar slots for Aura leads or eligible organic experiment variants.
     */
    async initCalendarSlots() {
        const unit = this.selectedUnit ?? this.cheapestUnitInTab;
        const unitId = parseInt(unit?.id, 10) || 0;
        if (!unitId) return;
        if (this._slotsUnitId && this._slotsUnitId !== unitId) this.showInlineCalendar = false;
        if (this._slotsUnitId && this._slotsUnitId !== unitId) this.mobileAgendaSheetOpen = false;

        const params = new URLSearchParams(window.location.search);
        const leadId = params.get('type') === 'agenda'
            ? parseInt(params.get('lead') ?? '', 10) || 0
            : 0;
        const isOrganicCalendar = this.calendarExperimentVariant === 'horario-visible' && unit.is_visitable;

        if (!leadId && !isOrganicCalendar) return;

        const slotsLeadId = leadId || null;
        if (
            this._slotsUnitId === unitId
            && this._slotsLeadId === slotsLeadId
            && this.hasTimeSlots()
        ) {
            // Cache hit: slots already loaded for this unit+lead.
            // Restore showInlineCalendar to true so the calendar stays visible
            // when returning to a tab whose unit matches the cached slots.
            this.showInlineCalendar = true;
            return;
        }

        if (this._calendarSlotsPromise) {
            await this._calendarSlotsPromise;
            return this.initCalendarSlots();
        }

        this.showInlineCalendar = false;
        this.mobileAgendaSheetOpen = false;
        this.resetTimeSlots();
        const corredores = unit.building?.corredores ?? this.building?.corredores;
        const brokerId = leadId ? null : (corredores?.fijo ?? corredores?.cabecera_1 ?? null);
        let loaded = false;

        try {
            this._calendarSlotsPromise = this.fetchAvailableTimeSlots(slotsLeadId, unitId, 1, brokerId);
            loaded = await this._calendarSlotsPromise;
        } finally {
            this._calendarSlotsPromise = null;
        }

        const currentUnitId = parseInt((this.selectedUnit ?? this.cheapestUnitInTab)?.id, 10) || 0;
        this.showInlineCalendar = currentUnitId === unitId && loaded && this.hasTimeSlots();
        // Ya NO se auto-selecciona el primer slot: el usuario debe elegir explícitamente
    },

    /** Auto-selecciona el primer slot disponible según el filtro AM/PM actual */
    _autoSelectFirstSlot() {
        const filteredSlots = this._getFilteredSlots();
        const firstAvailable = filteredSlots.find(s => s.available);
        if (firstAvailable) {
            this.selectedTime = firstAvailable.time;
        }
    },

    init() {
        const params = new URLSearchParams(window.location.search);

        // Sincronizar variante del experimento cuando el provider de flags esté listo.
        // Se lee directamente de globalThis.assetplanFlags (no de una closure stale)
        // para garantizar que se usa el provider real, no el stub.
        // Resetear solo el carrousel de horas cuando cambia la fecha (los slots son específicos por fecha)
        this.$watch('selectedDate', () => {
            this.timeSlotCarouselIndex = 0;
            // No resetear dateCarouselIndex — el usuario controla la página de fechas
        });

        // Resetear carrousel de horas al cambiar AM/PM
        // Ya NO se auto-selecciona el primer slot: el usuario debe elegir explícitamente
        this.$watch('timeFilter', () => {
            this.timeSlotCarouselIndex = 0;
        });

        // Verificar si la tipología está presente en la URL y agregarla si no está
        this.ensureTypologyInUrl();

        // Cargar filtros desde la URL
        this.loadFiltersFromUrl();

        // Verificar si hay una unidad en la URL para abrirla
        this.checkUrlForUnit();

        // Detección de modo reagendar: URL firmada desde visit-success-lead (?reschedule=1&unit_id=N&signature=...).
        // La firma se valida server-side cuando el usuario confirme el slot; acá solo preseleccionamos la unidad
        // y dejamos que el calendario inline se monte si además trae ?type=agenda&lead=N.
        const rescheduleParams = new URLSearchParams(window.location.search);
        if (rescheduleParams.get('reschedule') === '1') {
            const rescheduleUnitId = parseInt(rescheduleParams.get('unit_id') ?? '', 10);
            if (!isNaN(rescheduleUnitId) && rescheduleUnitId > 0) {
                this.selectedUnit = rescheduleUnitId;
            }
        }

        // A/B test botón QQMC y calendario: onReady dispara inmediatamente en dev (console provider)
        // y espera a PostHog en producción. Se lee directamente de globalThis.assetplanFlags
        // para garantizar que se usa el provider real, no una referencia stale.
        globalThis.assetplanFlags?.onReady(() => {
            this.ctaBotonQqmcVariant = globalThis.assetplanFlags.isEnabled(FLAG.AB_TEST_BOTON_QQMC)
                ? globalThis.assetplanFlags.getVariant(FLAG.AB_TEST_BOTON_QQMC)
                : FLAG.AB_TEST_BOTON_QQMC.CONTROL;
            this.calendarExperimentVariant = globalThis.assetplanFlags.isEnabled(FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA)
                ? globalThis.assetplanFlags.getVariant(FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA)
                : FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA.CONTROL;

            // Normalize legacy solo-agenda → horario-visible (C retired, B keeps its behavior)
            if (this.calendarExperimentVariant === 'solo-agenda') {
                this.calendarExperimentVariant = FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA.HORARIO_VISIBLE;
            }

            globalThis.calendarExperimentVariant = this.calendarExperimentVariant;
            this.initCalendarSlots();

            // Evento de exposición: PostHog lo usa para calcular conversiones por variante.
            // Se dispara una vez por sesión de página cuando la variante se asigna.
            // Solo para unidades elegibles: is_visitable === true (ambas variantes y sin importar leadId).
            // Helper idempotente: si la unidad todavía no está disponible retorna false sin disparar;
            // cualquier call site posterior (fetchModels o checkUrlForUnit) lo volvera a invocar.
            this.trackExperimentExposureIfEligible();

            // date_pick / time_pick: traducidos desde window events
            // emitidos por timeSlotsMixin en el calendario inline.
            // Sólo se disparan por click explícito del usuario.
            window.addEventListener('visit_scheduling:date_pick', (e) => {
                globalThis.assetplanAnalytics?.for('sitio_web').track('visit_scheduling:date_pick', {
                    date: e.detail?.date,
                    variant: this.calendarExperimentVariant,
                    surface: 'building',
                });
            });

            window.addEventListener('visit_scheduling:time_pick', (e) => {
                globalThis.assetplanAnalytics?.for('sitio_web').track('visit_scheduling:time_pick', {
                    time: e.detail?.time,
                    date: this.selectedDate,
                    variant: this.calendarExperimentVariant,
                    surface: 'building',
                });
            });
            // ponytail: cuando el POST a schedule-visit devuelve 422 (slot dejó de estar disponible),
            // el drawer schedule-visit dispatcha este evento. Recargamos los slots del calendario
            // inline y reseteamos selectedTime/selectedDate para que el usuario re-elige.
            window.addEventListener('visit_scheduling:slot_conflict', (e) => {
                this.selectedTime = null;
                this.selectedDate = null;
                this.reloadTimeSlots();
                this.triggerToast(e.detail?.message ?? 'Ese horario ya no está disponible. Elige otro.', 'error');
            });

            // B/C mobile: al confirmar agenda exitosamente, cerrar el sheet del calendario inline
            window.addEventListener('visit_scheduling:success', () => {
                this.mobileAgendaSheetOpen = false;
            });
        });

        // Watch for selectedUnit changes to trigger quote
        this.$watch('selectedUnit', (newValue, oldValue) => {
            if (newValue?.id) {
                // Evitar doble llamada si es la misma unidad y los parámetros derivados no han cambiado
                if (oldValue?.id === newValue.id &&
                    this.quoteParams.unit_id === newValue.id &&
                    this.quoteParams.want_parking === (newValue.has_parking || false) &&
                    this.quoteParams.want_store === (newValue.has_store || false)) {
                    return;
                }

                this.quoteParams.unit_id = newValue.id;
                this.quoteParams.want_parking = newValue.has_parking || false;
                this.quoteParams.want_store = newValue.has_store || false;
                //this.quoteParams.want_pet = newValue.acepta_mascotas || false;
                this.quoteParams.want_pet = false;
                this.getQuote();

                if(globalThis.assetplanAnalytics) {
                    let statusText = 'Lista para arrendar';
                    if(newValue.estado_vacios === 9){
                        statusText = 'Desarrollo inmobiliario';
                    } else if(newValue.estado_vacios === 12){
                        statusText = 'Re-acondicionamiento';
                    }
                    globalThis.assetplanAnalytics.for('sitio_web').track('unit_select', {
                        building: this.building.name,
                        unit_status: statusText,
                    })
                }

                // Actualizar URL cuando seleccionamos una unidad
                // Usar $nextTick para asegurar que el step se haya actualizado si viene de goTo()
                this.$nextTick(() => {
                    if (this.step === 'detail' || this.openDrawerUnits) {
                        this.updateUrlUnit(newValue.id);
                    }
                });
            } else if (oldValue?.id) {
                this.updateUrlUnit(null);
            }

            this.initCalendarSlots();
        });

        this.$watch('quoteParams.want_parking', () => {
            if (this.quoteParams.unit_id) this.getQuote();
        });
        this.$watch('quoteParams.want_store', () => {
            if (this.quoteParams.unit_id) this.getQuote();
        });
        this.$watch('quoteParams.want_pet', () => {
            if (this.quoteParams.unit_id) this.getQuote();
        });
        this.$watch('quoteParams.warranty_type', () => {
            if (this.quoteParams.unit_id) this.getQuote();
        });

        this.$watch('isAnyDrawerOpen', value => {
            if (value) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        });
        this.tabs = this.sortTypologies(this.tabs);
        
        // Initial fetch for active tab (OD)
        if (this.activeTab) {
             this.isLoadingModels = true;
              this.fetchModels(this.activeTab).then(async () => {
                 this.updateCurrentGroups(this.activeTab);
                 this.updateCurrentModels(this.activeTab);
                 // Recién acá cheapestUnitInTab tiene datos: initCalendarSlots() sale temprano sin ellos.
                 // Se espera antes de apagar isLoadingModels para que el spinner cubra también el fetch
                 // de available-hours; si no, se ve un hueco con los CTAs legacy antes del calendario.
                  await this.initCalendarSlots();
                  this.isLoadingModels = false;

                 // Call site 2: cheapestUnitInTab ya está disponible desde allGroupedUnits.
                 this.trackExperimentExposureIfEligible();
              });
        }

        this.updateBuildingPrices(this.activeTab);

        this.$nextTick(() => {
            const fixed = this.$refs.fixedBox;
            if (fixed) {
                // ponytail: un ResizeObserver cubre los tres casos de cambio de alto (expandir/colapsar el
                // bottom sheet, crecer el calendario al elegir fecha, cruzar el breakpoint lg) sin watchers extra.
                // Solo compensa cuando el panel está fuera de flujo (position:fixed = mobile);
                // en desktop es sticky, no tapa nada, y el padding-bottom debe ser 0.
                const measureBottomBox = () => {
                    this.bottomHeight = getComputedStyle(fixed).position === 'fixed' ? fixed.offsetHeight : 0;
                };
                measureBottomBox();
                new ResizeObserver(measureBottomBox).observe(fixed);
            }

            window.addEventListener('modal-share', () => {
                this.showModalShare = true;
            });

            window.addEventListener('share-done', () => {
                this.copyDone = true;
                setTimeout(() => { this.copyDone = false; }, 2000);
            });
        });

        window.addEventListener("scroll", () => this.handleScroll());

        // Cargar mapas estáticos
        this.$nextTick(() => {
            this.loadMap('mapa-building-multifamily', 10);
        });

        // Manejar navegación del browser (botón back del navegador)
        window.addEventListener('popstate', (event) => {
            if (this.openDrawerUnits) {
                this.handleBrowserBack(event);
            }
        });  
       
        // Usar el sistema completo de Referral.js
        // Leer UTMs desde window.utm (cubre URL actual + localStorage) en lugar de sólo params de URL
        this.formDataContactme.refer_code = window.referralCode ? window.referralCode.getValue() : '';
        const utmStored = window.utm ? (JSON.parse(window.utm.getValue() || 'null') || {}) : {};
        this.formDataContactme.utm_source = utmStored.utm_source || params.get('utm_source') || '';
        this.formDataContactme.utm_medium = utmStored.utm_medium || params.get('utm_medium') || '';
        this.formDataContactme.utm_campaign = utmStored.utm_campaign || params.get('utm_campaign') || '';
        this.formDataContactme.utm_content = utmStored.utm_content || params.get('utm_content') || '';
        this.formDataContactme.utm_term = utmStored.utm_term || params.get('utm_term') || '';
        this.formDataContactme.fbclid = window.fbclid ? window.fbclid.getValue() : (params.get('fbclid') || '');
        this.formDataContactme.gclid  = window.gclid  ? window.gclid.getValue()  : (params.get('gclid')  || '');
    },

    /**
     * Alias de selectedUnit para compatibilidad con los partials (unit-card, visit-success).
     * Devuelve la unidad seleccionada o la más barata disponible en la tipología activa.
     */
    get unit() {
        return this.selectedUnit || this.cheapestUnitInTab;
    },

    get isAnyDrawerOpen() {
        return this.openDrawerUnits || this.openDrawerMultifamily || this.openDrawerAvailable || this.openDrawerUnitNotFound || this.openModalGallery || this.showContactMeModal;
    },

    /**
     * Unidad disponible con menor precio del edificio.
     * Se usa como fallback cuando no hay selectedUnit al abrir un drawer.
     */
    get cheapestUnit() {
        const available = (this.units || []).filter(u => u.estado_vacios === 8);
        if (!available.length) return null;
        return available.reduce((cheapest, unit) => {
            const price = unit.price?.monto_depto ?? Infinity;
            const cheapestPrice = cheapest?.price?.monto_depto ?? Infinity;
            return price < cheapestPrice ? unit : cheapest;
        }, null);
    },

    /**
     * Unidad visitable con menor precio dentro de la tipología (tab) activa.
     *
     * Fuente: `allGroupedUnits[activeTab]` — array de modelos con campo `unidades`
     * populado por fetchModels(). Las unidades tienen `is_visitable` desde BuildingController
     * (processUnitsForListing). Si el tab aún no se cargó, retorna null.
     */
    get cheapestUnitInTab() {
        const models = this.allGroupedUnits[this.activeTab];
        if (!models || !models.length) return null;

        const available = models
            .flatMap(model => model.unidades ?? [])
            .filter(u => u.is_visitable === true && u.estado_vacios === 8);

        if (!available.length) return null;

        return available.reduce((cheapest, unit) => {
            const price = unit.price?.monto_depto ?? Infinity;
            return price < (cheapest?.price?.monto_depto ?? Infinity) ? unit : cheapest;
        }, null);
    },

    get cheapestContactableUnitInTab() {
        const models = this.allGroupedUnits[this.activeTab];
        if (!models || !models.length) return null;

        const units = models.flatMap(model => model.unidades ?? []);
        if (!units.length) return null;

        return units.reduce((cheapest, unit) => {
            const price = unit.price?.monto_depto ?? Infinity;
            return price < (cheapest?.price?.monto_depto ?? Infinity) ? unit : cheapest;
        }, null);
    },

    get navigationTitle() {
        if (this.step === 'list') return 'Seleccionar departamento';
        if (this.step === 'detail') return 'Departamento ' + (this.selectedUnit?.unidad || '');
        if (this.step === 'equipment') return 'Equipamiento';
        if (this.step === 'unit_photos') return 'Galería unidad ' + (this.selectedUnit?.unidad || '');
        if (this.step === 'no_availability') return 'Agendar visita';
        if (this.step === 'contact_me') return 'Solicitar contacto';
        if (this.step === 'visitor_form') return this.visitorFormMode === 'interest' ? 'Me interesa' : 'Agendar visita';
        if (this.step === 'schedule_visit') return 'Agendar visita';
        if (this.step === 'schedule_confirmation') return 'Agendar visita';
        if (this.step === 'schedule_success') return '';
        if (this.step === 'success_with_schedule') return '';
        return '';
    },

    get navigationShowBack() {
        // En schedule_success y success_with_schedule no se muestra el botón back
        if (this.step === 'schedule_success') return false;
        if (this.step === 'success_with_schedule') return false;
        return this.history?.length > 0;
    },

    // ============================================================
    // Visitor form — computed getters
    // ============================================================
    // ============================================================
    // Similar buildings carousel (usado por similar-buildings-carousel
    // y visit-success directamente en el scope buildingPage)
    // ============================================================
    similarBuildingsDisplay() {
        if (!this.similarBuildings.length) return [];
        return [...this.similarBuildings, this.similarBuildings[0]];
    },
    sbNext() {
        const len = this.similarBuildings.length;
        if (!len) return;
        this._sbTransition = true;
        this.similarBuildingsIndex++;
        if (this.similarBuildingsIndex === len) {
            setTimeout(() => {
                this._sbTransition = false;
                this.similarBuildingsIndex = 0;
                requestAnimationFrame(() => requestAnimationFrame(() => {
                    this._sbTransition = true;
                }));
            }, 320);
        }
    },
    sbPrev() {
        const len = this.similarBuildings.length;
        if (!len) return;
        this._sbTransition = true;
        this.similarBuildingsIndex = this.similarBuildingsIndex === 0 ? len - 1 : this.similarBuildingsIndex - 1;
    },
    resetSimilarBuildings() {
        this.similarBuildings      = [];
        this.similarBuildingsIndex = 0;
        this._sbTransition         = true;
    },

    get canSubmitVisitorForm() {
        return (this.form?.name ?? '').trim() &&
               (this.form?.rut ?? '').trim() &&
               this.validateRut(this.form?.rut) &&
               /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form?.email ?? '') &&
               (this.form?.phone ?? '').length >= 8 &&
               (this.form?.phone ?? '').length <= 15 &&
               this.form?.terms &&
            ((this.form?.movingTimeline !== null && this.showMovingTimeline) || !this.showMovingTimeline);
    },

    get canSubmitProfile() {
        return this.profileForm.hasGuarantor !== null
            && this.profileForm.hasIncome !== null;
    },

    get shouldOfferScheduling() {
        const unit = this.selectedUnit ?? this.cheapestUnitInTab;
        return unit?.is_visitable && this.form?.movingTimeline !== null && this.form?.movingTimeline <= 30;
    },


    async goTo(nextStep) {
        // Agregar feedback visual durante la navegación
        this.isNavigating = true;
        this.navigationDirection = 'forward';

        // Agregar el paso actual al historial
        this.history.push(this.step);

        // Si estamos navegando fuera de detail (y no es a unit_photos), limpiar unit_id
        if (this.step === 'detail' && nextStep !== 'detail' && nextStep !== 'unit_photos') {
            this.updateUrlUnit(null);
        }

        if(nextStep === 'visitor_form' && this.visitorFormMode === 'schedule') {
            this.showMovingTimeline = false;
            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:start_button_click', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                    from: 'landing',
                    property_state: this.selectedUnit.is_visitable ? 'available' : 'unavailable',
                })
            }
        }


        if(nextStep === 'visitor_form' && this.visitorFormMode === 'interest') {
            this.showMovingTimeline = true;
            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('action_start', {
                    action_type: 'contact_me',
                    from: 'unit',
                    ab_boton_qqmc: this.ctaBotonQqmcVariant,
                })
            }
        }

        if(nextStep === 'schedule_confirmation') {
            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:date_select', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                    origin: this.visitorFormMode === 'schedule' ? 'visit_scheduling' : 'im_intrerested',
                })
            }
        }

        if(nextStep === 'schedule_success') {
            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:summary_page_view', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                    origin: this.visitorFormMode === 'schedule' ? 'visit_scheduling' : 'im_intrerested',
                })
            }
        }

        // Si nextStep es contact_me hago el fetch al controlador contactme para obtener hasbroker
        if(nextStep === 'contact_me'){
           await this.fetchContactmeController();
            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('action_start', {
                    action_type: 'contact_me',
                    from: 'unit',
                    ab_boton_qqmc: this.ctaBotonQqmcVariant,
                })
            }
        }
        

        const executeGoTo = () => {
            this.step = nextStep;
            this.resetScroll();

            this.$nextTick(() => {
                setTimeout(() => {
                    this.isNavigating = false;
                }, 300);
            });
        };

        if (document.startViewTransition) {
            document.startViewTransition(() => executeGoTo());
        } else {
            executeGoTo();
        }
    },
  
    back() {
        if (this.history.length > 0) {
            // Validar que no estemos ya navegando
            if (this.isNavigating) {
                return;
            }

            // Agregar feedback visual durante la navegación hacia atrás
            this.isNavigating = true;
            this.navigationDirection = 'backward';

            // Obtener el paso previo ANTES de entrar en el async
            const previousStep = this.history.pop();

            // Si estamos saliendo de detail (y no volvemos a unit_photos), limpiar unit_id de la URL
            // Mantener selectedUnit para evitar el parpadeo de placeholders durante la animación
            if (this.step === 'detail' && previousStep !== 'detail' && previousStep !== 'unit_photos') {
                this.updateUrlUnit(null);
            } else if (this.step === 'unit_photos' && previousStep !== 'detail') {
                this.updateUrlUnit(null);
            }

            const executeBack = () => {
                const oldStep = this.step;
                this.step = previousStep;
                this.resetScroll();

                // Mantener actualizada la lista si volvemos desde el detalle
                if (this.step === 'list' && oldStep === 'detail') {
                    this.refreshModelUnits(true); // showLoading = true como solicitó el usuario
                }

                // Limpiar la unidad seleccionada solo después de que la transición haya avanzado
                // o cuando volvemos a la lista principal
                setTimeout(() => {
                    this.isNavigating = false;
                    if (this.step === 'list') {
                        this.selectedUnit = null;
                    }
                }, 300);
            };

            if (document.startViewTransition) {
                document.startViewTransition(() => executeBack());
            } else {
                executeBack();
            }
        } else {

            // Si no hay historial, cerrar el drawer como fallback
            this.closeDrawer();
        }
    },

    handleBrowserBack(event) {
        // Prevenir el comportamiento por defecto si estamos navegando dentro del drawer
        if (this.history.length > 0 && this.openDrawerUnits) {
            event.preventDefault();
            this.back();
        } else if (this.openDrawerUnits) {
            // Si no hay historial pero el drawer está abierto, cerrarlo
            event.preventDefault();
            this.closeDrawer();
        }
    },

    resetScroll() {
        this.$nextTick(() => {
            const container = document.getElementById('drawer-navigation-content');
            if (container) container.scrollTop = 0;
        });
    }, 
   
    closeDrawer() {
        // Agregar feedback visual al cerrar
        this.isNavigating = true;
        this.openDrawerUnits = false;

        // Limpiar unit_id de la URL inmediatamente
        this.updateUrlUnit(null);

        setTimeout(() => {
            this.step = 'list';
            this.history = [];
            this.selectedUnit = null;
            this.isNavigating = false;
            this.resetVisitorFlow();
        }, 300);
    },

    // ============================================================
    // Visitor form — métodos
    // ============================================================

    resetVisitorFlow() {
        this.form = { name: '', rut: '', email: '', phone: '', code_phone: '56', terms: false, movingTimeline: null };
        this.visitorFormMode = 'schedule';
        this.errors = { name: '', last_name: '', rut: '', email: '', phone: '', terms: '', reason: '' };
        this.resetTimeSlots();
        this.profileForm = { movingTimeline: null, hasGuarantor: null, hasIncome: null };
        this.reqOpen = false;
        this.sending = false;
        this.leadId = null;
        this.brokerId = null;
        this.similarBuildings      = [];
        this.similarBuildingsIndex = 0;
        this._sbTransition         = true;
    },

    /**
     * Abre el drawer autónomo schedule-visit desde los CTAs externos (sticky bar).
     */
    openScheduleVisit() {
        if (!this.selectedUnit) this.selectedUnit = this.cheapestUnitInTab;
        const unit     = this.selectedUnit;
        if (!unit?.is_visitable) return;
        const building = unit?.building ?? this.building;

        // Mobile + variantes B/C: abre el sheet del Inline Calendar (no el drawer legacy).
        const isMobile = window.matchMedia('(max-width: 1023px)').matches;
        const variant = this.calendarExperimentVariant;
        const isExperimentalAgenda = variant === 'horario-visible';
        if (isMobile && isExperimentalAgenda) {
            this.mobileAgendaSheetOpen = true;
            return;
        }

        window.dispatchEvent(new CustomEvent('schedule-visit-open', {
            detail: { unit_id: unit?.id, building },
        }));

        if(globalThis.assetplanAnalytics){
            globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:start_button_click', {
                building_type: building.multifamily ? 'multifamily' : 'retail',
                from: 'landing',
                property_state: 'available',
            })
        }
    },

    /**
     * Preview local de los próximos 7 días hábiles (Mon–Sat, descarta hoy si ya pasaron las 14:00).
     * La disponibilidad real se valida después de crear el lead en confirmSlot().
     */
    previewDays() {
        const days = [];
        const today = new Date(); today.setHours(0, 0, 0, 0);
        const skipToday = new Date().getHours() >= 14;
        for (let i = skipToday ? 1 : 0; i < 7; i++) {
            const d = new Date(today);
            d.setDate(today.getDate() + i);
            if (d.getDay() === 0) continue; // skip Sunday
            const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            days.push({ iso, date: d, available: true, hasFreeSlot: true });
        }
        return days;
    },

    /** Opens the organic scheduling drawer with the selected slot. */
    confirmSlot() {
        if (!this.selectedDate || !this.selectedTime) return;
        const unit = this.selectedUnit ?? this.cheapestUnitInTab;
        if (!unit?.id) return;

        window.dispatchEvent(new CustomEvent('schedule-visit-open-with-slot', {
            detail: {
                unit_id: unit.id,
                building: unit.building ?? this.building,
                date: this.selectedDate,
                time: this.selectedTime,
            },
        }));
    },

    /**
     * Variante de confirmSlot() para el path con lead en URL (?type=agenda&lead=N).
     * Reusa el drawer legacy schedule-visit con el slot pre-seleccionado del calendario inline.
     */
    confirmSlotWithLead() {
        const unit = this.selectedUnit ?? this.cheapestUnitInTab;
        const leadId = parseInt(new URLSearchParams(window.location.search).get('lead') ?? '', 10) || 0;
        if (!unit?.id || !leadId || !this.selectedDate || !this.selectedTime) {
            alert('Por favor selecciona fecha y hora antes de continuar.');
            return;
        }
        window.dispatchEvent(new CustomEvent('schedule-visit-open', {
            detail: {
                unit_id: unit.id,
                building: this.building,
                leadId: leadId,
                selectedDate: this.selectedDate,
                selectedTime: this.selectedTime,
            },
        }));
    },

    /**
     * Abre el drawer autónomo im-interested desde los CTAs externos (sticky bar).
     */
    openImInterested() {
        if (!this.selectedUnit) this.selectedUnit = this.cheapestContactableUnitInTab;
        const unit     = this.selectedUnit;
        const building = this.building;
        window.dispatchEvent(new CustomEvent('im-interested-open', {
            detail: { unit, building },
        }));

        if(globalThis.assetplanAnalytics){
            globalThis.assetplanAnalytics.for('sitio_web').track('action_start', {
                action_type: 'contact_me',
                from: 'landing',
                ab_boton_qqmc: this.ctaBotonQqmcVariant,
            })
        }
    },

    validateVisitorField(field) {
        const f = this.form;
        if (field === 'name') {
            this.errors.name = f.name.trim() ? '' : 'El nombre es requerido';
        }
        if (field === 'rut') {
            if (!f.rut.trim()) {
                this.errors.rut = 'El RUT es requerido';
            } else if (!this.validateRut(f.rut)) {
                this.errors.rut = 'El RUT ingresado no es válido';
            } else {
                this.errors.rut = '';
            }
        }
        if (field === 'email') {
            if (!f.email.trim()) {
                this.errors.email = 'El correo es requerido';
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) {
                this.errors.email = 'Ingresa un correo válido';
            } else {
                this.errors.email = '';
            }
        }
        if (field === 'phone') {
            if (!f.phone.trim()) {
                this.errors.phone = 'El teléfono es requerido';
            } else if (f.phone.length > 15) {
                this.errors.phone = 'El teléfono no puede tener más de 15 dígitos';
            } else if (f.phone.length < 8) {
                this.errors.phone = 'Ingresa un número válido (mínimo 8 dígitos)';
            } else {
                this.errors.phone = '';
            }
        }
        if (field === 'terms') {
            this.errors.terms = f.terms ? '' : 'Debes aceptar los términos';
        }
    },

    validateRut(rut) {
        if (!rut || typeof rut !== 'string') return false;
        const cleaned = rut.replace(/[^0-9kK]/g, '');
        if (cleaned.length < 8) return false;
        const body = cleaned.slice(0, -1);
        const dv = cleaned.slice(-1).toLowerCase();
        let sum = 0;
        let multiplier = 2;
        for (let i = body.length - 1; i >= 0; i--) {
            sum += parseInt(body[i]) * multiplier;
            multiplier = multiplier === 7 ? 2 : multiplier + 1;
        }
        const expectedDv = 11 - (sum % 11);
        const expectedDvStr = expectedDv === 11 ? '0' : expectedDv === 10 ? 'k' : String(expectedDv);
        return dv === expectedDvStr;
    },

    formatRut(value) {
        if (!value) return '';
        let cleaned = value.replace(/[^0-9kK]/g, '');
        if (cleaned.length === 0) return '';
        cleaned = cleaned.slice(0, 9);
        if (cleaned.length < 2) return cleaned;
        let body = cleaned.slice(0, -1);
        let dv = cleaned.slice(-1).toUpperCase();
        let formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return formattedBody + '-' + dv;
    },

    formatPhone(digits, code) {
        if (!digits) return '';
        const d = String(digits).replace(/\D/g, '').slice(0, 15);
        if (code === '56') {
            const c = d.slice(0, 9);
            if (c.length <= 1) return c;
            if (c.length <= 5) return c[0] + ' ' + c.slice(1);
            return c[0] + ' ' + c.slice(1, 5) + ' ' + c.slice(5);
        }
        return d;
    },

    /**
     * Envía el formulario de contacto (visitor_form).
     * Crea el Lead via POST /im-interested, guarda lead_id.
     * Si la unidad es visitable → schedule_visit; si no → schedule_success.
     */
    async submitVisitorForm() {
        this.validateVisitorField('name');
        this.validateVisitorField('rut');
        this.validateVisitorField('email');
        this.validateVisitorField('phone');
        this.validateVisitorField('terms');
        // En modo "schedule" la pregunta de mudanza se hace en el paso 3 (profileForm), no aquí.
        const missingMovingTimeline = this.showMovingTimeline && this.form.movingTimeline === null;
        if (this.errors.name || this.errors.rut || this.errors.email || this.errors.phone || this.errors.terms || missingMovingTimeline) {
            return;
        }
        if (!this.canSubmitVisitorForm || this.sending) return;
        this.sending = true;
        try {
            const unit = this.selectedUnit || this.cheapestUnitInTab;

            // Separar nombre completo en nombre y apellido
            const nameParts = (this.form.name || '').trim().split(/\s+/);
            const firstName  = nameParts[0] || '';
            const lastName   = nameParts.slice(1).join(' ') || firstName;

            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
            const url = `${globalThis.location.origin}/arriendo/departamento/im-interested`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    name: firstName,
                    last_name: lastName,
                    email: this.form.email,
                    code_phone: this.form.code_phone,
                    phone: this.form.phone,
                    unit_id: unit?.id,
                    rut: this.form.rut,
                    terms: this.form.terms ? '1' : '0',
                    moving_timeline: this.form.movingTimeline,
                    call_to_action: this.visitorFormMode === 'interest' ? 'portal.contactame' : 'portal.visita',
                    experiment_variant: this.calendarExperimentVariant ?? null,
                    refer_code: window.referralCode ? window.referralCode.getValue() : '',
                    fbclid: window.fbclid ? window.fbclid.getValue() : '',
                    gclid: window.gclid  ? window.gclid.getValue()  : '',
                    ...(window.utm ? (JSON.parse(window.utm.getValue() || 'null') || {}) : {}),
                }),
            });

            if(this.visitorFormMode === 'schedule') {
                if(globalThis.assetplanAnalytics){
                    globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:basic_info_form_submit', {
                        building_type: building.multifamily ? 'multifamily' : 'retail',
                    })
                }
            }

            if(this.visitorFormMode === 'interest') {
                if(globalThis.assetplanAnalytics){
                    globalThis.assetplanAnalytics.for('sitio_web').track('contact_form_submit')
                }
            }

            const data = await response.json();

            if (!response.ok) {
                this.triggerToast(data?.message ?? 'Error al enviar el formulario.', 'error');
                return;
            }

            this.leadId = data.lead_id;
            this.brokerId = data.broker_id ?? null;

            if (this.visitorFormMode === 'interest') {
                // Flujo "me interesa": siempre va a success_with_schedule
                // Si la unidad es visitable y mudanza próxima, precargar horarios (auto-selecciona primer día)
                if (this.shouldOfferScheduling) {
                    await this.fetchAvailableTimeSlots(data.lead_id, unit?.id);
                }
                await this.fetchSimilarBuildings();
                this.goTo('success_with_schedule');
            } else {
                // Flujo "agendar visita": si la unidad es visitable, forza el paso de selección de fecha
                // (la fecha de mudanza se pregunta en el paso 3, igual que el componente schedule-visit).
                if (data.is_visitable) {
                    // Fetch interno independiente: el calendario de schedule_visit tiene su propio estado,
                    // sin copiar ni depender del calendario externo.
                    this.scheduleVisitCalendar.resetTimeSlots();
                    await this.scheduleVisitCalendar.fetchAvailableTimeSlots(data.lead_id, unit?.id);
                    this.goTo('schedule_visit');
                } else {
                    await this.fetchSimilarBuildings();
                    this.goTo('schedule_success');
                }
            }
        } catch (err) {
            console.error('[submitVisitorForm]', err);
            this.triggerToast('Error al enviar el formulario.', 'error');
        } finally {
            this.sending = false;
        }
    },

    /**
     * Envía el perfil de arriendo (paso 3 schedule_confirmation).
     * Crea el ScheduleLead via POST /schedule-visit.
     */
    async submitScheduleConfirmation() {
        if (!this.canSubmitProfile || this.sending) return;
        // ponytail: guard against POST with null slot in horario-visible variant.
        // The inline calendar auto-selects the first day/slot, but if the user reaches
        // step 3 without a valid slot, abort and notify instead of sending null to the backend.
        if (!this.scheduleVisitCalendar.selectedDate || !this.scheduleVisitCalendar.selectedTime) {
            console.error('[submitScheduleConfirmation] sin slot preelegido', {
                selectedDate: this.scheduleVisitCalendar.selectedDate,
                selectedTime: this.scheduleVisitCalendar.selectedTime,
                variant: this.calendarExperimentVariant,
            });
            this.triggerToast('Por favor selecciona una fecha y hora antes de continuar.', 'error');
            this.goTo('schedule_visit');
            return;
        }
        this.sending = true;
        try {
            const unit = this.selectedUnit || this.cheapestUnitInTab;
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
            const url = `${globalThis.location.origin}/arriendo/departamento/schedule-visit`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    lead_id:      this.leadId,
                    unit_id:      unit?.id,
                    agenda_fecha: this.scheduleVisitCalendar.selectedDate,
                    agenda_hora:  this.scheduleVisitCalendar.selectedTime,
                    has_guarantor: this.profileForm.hasGuarantor,
                    has_income:    this.profileForm.hasIncome,
                    moving_timeline: this.profileForm.movingTimeline,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                this.triggerToast(data?.message ?? 'Error al agendar la visita.', 'error');
                if (response.status === 422) {
                    // El horario dejó de estar disponible: volver a elegir con horarios frescos
                    // usando el calendario interno, no el externo.
                    await this.scheduleVisitCalendar.reloadTimeSlots();
                    this.goTo('schedule_visit');
                }
                return;
            }

            await this.fetchSimilarBuildings();

            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:requirements_info_submit', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                })
            }

            this.goTo('schedule_success');
        } catch (err) {
            console.error('[submitScheduleConfirmation]', err);
            this.triggerToast('Error al agendar la visita.', 'error');
        } finally {
            this.sending = false;
        }
    },

    async fetchSimilarBuildings() {
        const unit = this.selectedUnit || this.cheapestUnitInTab;
        const communeId = unit?.commune_id 
            ?? unit?.building?.commune_id 
            ?? unit?.building?.comuna_id 
            ?? unit?.comuna_id 
            ?? this.building?.commune_id 
            ?? this.building?.comuna_id;
        const buildingId = unit?.building_id 
            ?? unit?.building?.building_id 
            ?? unit?.building?.id 
            ?? this.building?.building_id 
            ?? this.building?.id;

        if (!communeId) return;
        try {
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
            const response = await fetch('/api/buildings/search-by-commune', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ commune_id: communeId, limit: 6 }),
            });
            if (!response.ok) return;
            const data = await response.json();
            const buildings = data.data?.buildings || data.buildings || [];
            this.similarBuildings = buildings
                .filter(b => (b.building_id ?? b.id) !== buildingId)
                .slice(0, 4);
        } catch (err) {
            console.error('[fetchSimilarBuildings] error:', err);
        }
    },

    slug(text) {
        if (!text) return '';
        let str = text.name ?? text.nombre ?? text;
        return str.toString().toLowerCase().trim().normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '').replace(/ñ/g, 'n')
            .replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    },

    async getQuote() {
        if (!this.quoteParams.unit_id) return;

        this.isLoadingQuote = true;
        const endpoint = `${this.apiUrl}quotation/preview`;

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Api-Token': import.meta.env.VITE_API_TOKEN
                },
                body: JSON.stringify(this.quoteParams)
            });

            if (!response.ok) throw new Error('Error en la petición');

            const data = await response.json();

            if (data.status === 'success') {
                this.quote = data.quote;
            }

        } catch (error) {
            console.error('Error obteniendo cotización:', error);
        } finally {
            this.isLoadingQuote = false;
        }
    },

    loadMap(container, time) {
        setTimeout(() => {
            if (typeof Mapbox === 'undefined') {
                console.warn('Mapbox aún no está disponible, reintentando...');
                setTimeout(() => this.loadMap(container, time), 100);
                return;
            }

            const [lat, lng] = this.building.latlng.split(',').map(coord => parseFloat(coord.trim()));

            Mapbox.makeMap(container, {
                zoom: 15,
                center: [lng, lat],
                minZoom: 11,
                maxZoom: 17,
                interactive: false
            },
            {
                showZoom: false
            });

            Mapbox.addMarker({
                center: [lng, lat]
            });

            Mapbox.resize();
        }, time);
    }, 
    
    async setActiveTab(slug) {
        this.isLoadingModels = true;
        if (this.activeTab !== slug) this.showInlineCalendar = false;
        if (this.activeTab !== slug) this.mobileAgendaSheetOpen = false;
        this.activeTab = slug;
        this.processedModels = [];

        this.updateBuildingPrices(slug);
        this.scrollToSection(slug);
        this.updateUrl(slug);

        await this.fetchModels(slug);

        this.updateCurrentGroups(slug); 
        this.updateCurrentModels(slug);
        await this.initCalendarSlots();
        this.isLoadingModels = false;
    },

    async fetchModels(slug) {
        if (!slug) return;
        try {
            const response = await fetch(`/arriendo/departamento/buildings/${this.building.id}/models/${slug}`);
            if (response.ok) {
                const data = await response.json();

                // Extraer modelos y convertirlos a objeto indexado por ID/nombre para compatibilidad
                const models = {};
                if (data.models && Array.isArray(data.models)) {
                    data.models.forEach(m => {
                        const key = m.id_plano || m.plano_table_tipologias_id || m.nombre || Math.random().toString();
                        models[key] = m;
                    });
                } else if (data.models) {
                    // Si ya es un objeto, usarlo directamente
                    Object.assign(models, data.models);
                }

                //sort by unidades desc
                const planosOrdenados = Object.entries(models)
                .sort((a, b) => b[1].unidades.length - a[1].unidades.length)
                .map(([id, plano]) => ({ id, ...plano }));

                this.allGroupedUnits[slug] = planosOrdenados;
                if (!this.originalGroupedUnits[slug]) {
                    this.originalGroupedUnits[slug] = JSON.parse(JSON.stringify(planosOrdenados));
                }

                // Actualizar información global de super promo del edificio
                if (data.super_promo !== undefined) {
                    this.building.super_promo = data.super_promo;
                    this.building.benefits_promo = data.benefits_promo;
                    this.building.flex = data.flex;
                    this.building.badges = data.badges;
                }

                // Detecta si existe requisito y guarda el valor máximo encontrado (> 0)
                const titularIncomeValues = planosOrdenados
                    .flatMap(plano => plano.unidades)
                    .map(unidad => Number(unidad?.price?.cantidad_rentas_titular) || 0)
                    .filter(value => value > 0);

                const titularIncomeRequirementValue = titularIncomeValues.length > 0
                    ? Math.max(...titularIncomeValues)
                    : 0;

                const hasTitularIncomeRequirement = titularIncomeRequirementValue > 0;
                this.building.has_titular_income_requirement = hasTitularIncomeRequirement;
                this.building.titular_income_requirement_value = titularIncomeRequirementValue;
            }
        } catch (e) {
            console.error('Error fetching models:', e);
        }
    },

    updateBuildingPrices(slug) {
        if (!this.building.available_typologies_tabs) return;
        const typology = this.building.available_typologies_tabs.find(t => t.slug === slug);
        if (typology) {
            this.building.min_price = typology.min_price;
            this.building.min_ggcc_fijo = typology.min_ggcc;
            this.building.has_discount = typology.has_discount ? 1 : 0;
        }
    },

    updateUrl(slug) {
        const currentUrl = new URL(window.location.href);
        const pathSegments = currentUrl.pathname.split('/');

        // La URL es /arriendo/departamento/{building_id}/{building_name}/{typology}
        if (pathSegments.length >= 7) {
            pathSegments[6] = slug;
            currentUrl.pathname = pathSegments.join('/');

            // Al cambiar de tipología, removemos el unit_id de los query params
            currentUrl.searchParams.delete('unit_id');


            // Usar replaceState para no acumular entradas en el historial
            window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);
        }
    },

    // Devuelve la URL completa de una tipología para usarla en <a href>.
    // Permite que los crawlers descubran las URLs de tipología como links internos
    // sin depender de window.open() ni replaceState().
    getBuildingTypologyUrl(slug) {
        const currentUrl = new URL(window.location.href);
        const pathSegments = currentUrl.pathname.split('/');
        if (pathSegments.length >= 7) {
            const newSegments = [...pathSegments];
            newSegments[6] = slug;
            return newSegments.join('/');
        }
        return currentUrl.pathname;
    },

    updateUrlUnit(unitId) {
        const currentUrl = new URL(window.location.href);

        if (unitId) {
            currentUrl.searchParams.set('unit_id', unitId);
        } else {
            currentUrl.searchParams.delete('unit_id');
        }


        // Usar replaceState para no acumular entradas en el historial del navegador
        window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);
    },

    ensureTypologyInUrl() {
        const currentUrl = new URL(window.location.href);
        const pathSegments = currentUrl.pathname.split('/');

        // La URL es /arriendo/departamento/{commune}/{building_id}/{building_name}/{typology}
        // Si no hay tipología en la posición 4 o está vacía, agregar 'estudio'
        if (pathSegments.length < 7 || !pathSegments[6] || pathSegments[6].trim() === '') {
            // Usar la primera tipología disponible o 'estudio' por defecto
            const defaultTypology = this.getDefaultTypology();
            pathSegments[6] = defaultTypology;

            // Reconstruir la URL completa
            currentUrl.pathname = pathSegments.join('/');

            // Reemplazar la URL actual sin agregar entrada al historial
            window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);

            // Actualizar el activeTab para reflejar la tipología seleccionada
            this.activeTab = defaultTypology;

            // Actualizar grupos, modelos y precios para la nueva tipología
            this.updateCurrentGroups(defaultTypology);
            this.updateCurrentModels(defaultTypology);
            this.updateBuildingPrices(defaultTypology);

            console.log(`Tipología añadida automáticamente a la URL: ${defaultTypology}`);
        }
    },

    getDefaultTypology() {
        // Verificar si hay tipologías disponibles y usar la primera según el orden establecido
        if (this.tabs && this.tabs.length > 0) {
            // Si no se encuentra ninguna de las tipologías del orden, usar la primera disponible
            return this.tabs[0].slug;
        }
        // Fallback a 'estudio' si no hay tipologías disponibles
        return 'estudio';
    },
    async fetchUnitById(unitId) {
        try {
            const response = await fetch(`/arriendo/departamento/units/${unitId}`);
            if (!response.ok) {
                return null;
            }
            const unit = await response.json();
            return unit;
        } catch (error) {
            console.error("Error fetching unit by ID:", error);
            return null;
        }
    },
    async checkUrlForUnit() {
        const params = new URLSearchParams(window.location.search);
        const unitId = parseInt(params.get('unit_id') ?? params.get('selectedUnit'));

        if (unitId && !isNaN(unitId)) {
            try {
                // Llamar al endpoint para obtener la unidad
                const response = await fetch(`/arriendo/departamento/units/${unitId}`);

                // Caso: Unidad no encontrada (404)
                if (!response.ok) {
                    await this.handleUnitNotFound(unitId);
                    return;
                }

                const unit = await response.json();

                if (unit) {
                    // Encontrar modelo y slug
                    let foundSlug = null;
                    let foundModelName = null;
                    let foundModelData = null;
                    
                    // OD: Ensure we have the models for this unit's typology
                    const typologyName = unit.typology?.tipologia || unit.tipologia;
                    const bedrooms = unit.typology?.bedrooms ?? unit.bedrooms;
                    
                    let targetSlug = null;
                    if (typologyName === 'Estudio') targetSlug = 'estudio';
                    else if (bedrooms === 1) targetSlug = '1-dormitorio';
                    else if (bedrooms === 2) targetSlug = '2-dormitorios';
                    else if (bedrooms === 3) targetSlug = '3-dormitorios';
                    else if (bedrooms >= 4) targetSlug = '4-o-mas-dormitorios';
                    
                    if (targetSlug && (!this.allGroupedUnits[targetSlug] || Object.keys(this.allGroupedUnits[targetSlug]).length === 0)) {
                         await this.fetchModels(targetSlug);
                    }

                    // Buscar en originalGroupedUnits usando plano_tipo_id si está disponible, o iterando
                    // We must use allGroupedUnits as it is now populated
                    const sourceGrouped = this.allGroupedUnits;

                    // Estrategia 1: Usar plano_tipo_id si viene en la unidad
                    if (unit.plano_tipo_id) {
                         for (const [slug, models] of Object.entries(sourceGrouped)) {
                            for (const [modelName, modelData] of Object.entries(models)) {
                                if (modelData.id_plano === unit.plano_tipo_id) {
                                    foundSlug = slug;
                                    foundModelName = modelName;
                                    foundModelData = modelData;
                                    break;
                                }
                            }
                            if (foundSlug) break;
                        }
                    }

                    // Estrategia 2: Si no se encontró por ID de plano (o no venía), buscar si la unidad ya estaba en la data local (fallback)
                    if (!foundSlug) {
                         for (const [slug, models] of Object.entries(sourceGrouped)) {
                            for (const [modelName, modelData] of Object.entries(models)) {
                                if (modelData.unidades && modelData.unidades.some(u => u.id === unit.id)) {
                                    foundSlug = slug;
                                    foundModelName = modelName;
                                    foundModelData = modelData;
                                    break;
                                }
                            }
                            if (foundSlug) break;
                        }
                    }

                    if (foundSlug) {
                        // Cambiar tab si es necesario
                        if (this.activeTab !== foundSlug) {
                            this.setActiveTab(foundSlug);
                        }

                        // Preparar selectedModel minimal para el detalle inmediato
                        const modelInfo = this.getModelInfo(foundModelName, foundModelData);
                        const idPlano = foundModelData.id_plano ? foundModelData.id_plano : foundModelData.plano_table_tipologias_id;
                        const hasIdPlano = !!foundModelData.id_plano;

                        this.selectedModel = {
                            name: modelInfo.title,
                            img: modelInfo.img,
                            id_plano: idPlano,
                            has_id_plano: hasIdPlano,
                            units: foundModelData.unidades || [],
                            availableUnitsList: (foundModelData.unidades || []).filter(u => u.is_visitable),
                            unavailableUnitsList: (foundModelData.unidades || []).filter(u => !u.is_visitable),
                            availableUnits: (foundModelData.unidades || []).filter(u => u.is_available).length
                        };

                        // Configurar navegación inmediata para evitar saltos
                        this.selectedUnit = unit;
                        this.step = 'detail';
                        this.history = ['list'];
                        this.isLoadingUnitDetail = true;
                        this.openDrawerUnits = true;

                        if (params.get('agendar') === '1' && unit.is_visitable) {
                            this.$nextTick(() => {
                                this.visitorFormMode = 'schedule';
                                this.goTo('visitor_form');
                            });
                        }

                        try {
                             // Fetch de todas las unidades del modelo de forma asíncrona pero sin bloquear la vista de detalle
                            let url = `/arriendo/departamento/buildings/${this.building.id}/units?`;
                            if (hasIdPlano) {
                                url += `plano_id=${idPlano}`;
                            } else {
                                url += `typology_id=${idPlano}`;
                            }
                            const unitsResponse = await fetch(url);
                            let freshUnits = [];

                            if (unitsResponse.ok) {
                                freshUnits = await unitsResponse.json();
                            } else {
                                freshUnits = [unit];
                            }

                            // Filtrar unidades respetando filtros
                            let filteredFreshUnits = freshUnits.filter(u => this.unitMatchesFilters(u));

                            // Asegurar que la unidad seleccionada esté presente
                            if (!filteredFreshUnits.some(u => u.id === unit.id)) {
                                filteredFreshUnits.push(unit);
                            }

                            const available = filteredFreshUnits.filter(u => u.is_visitable);
                            const unavailable = filteredFreshUnits.filter(u => !u.is_visitable);

                            // Caso: La unidad existe pero NO está disponible
                            if (!unit.is_available) {
                                this.openDrawerUnits = false;
                                await this.handleUnitNotAvailable(unit, foundModelData, modelInfo, available, unavailable);
                                return;
                            }

                            // Actualizar selectedModel con data fresca
                            this.selectedModel.units = filteredFreshUnits;
                            this.selectedModel.availableUnitsList = available;
                            this.selectedModel.unavailableUnitsList = unavailable;
                            this.selectedModel.availableUnits = available.length;

                            // Refrescar también la unidad para obtener detalles completos (si faltan)
                            const fullUnit = await this.fetchUnitById(unit.id);
                            if (fullUnit) {
                                this.selectedUnit = fullUnit;

                                if (params.get('video') === '1' && this.selectedUnit.url_videos?.length > 0) {
                                    this.tabSelectedGallery = 'videos';
                                    this.goTo('unit_photos');
                                }
                            }

                        } catch (e) {
                            console.error("Error cargando data adicional para la unidad", e);
                        } finally {
                            this.isLoadingUnitDetail = false;
                        }

                        // Call site 3: selectedUnit quedó asignada y fetchModels(targetSlug) si fue necesario ya resolvió.
                        // Este es el punto de entrada para navegación directa a unidad (Landing MF / Retail).
                        this.trackExperimentExposureIfEligible();
                    } else {
                        // No se encontró el modelo en los datos locales
                        await this.handleUnitNotFound(unitId, unit);
                    }
                }
            } catch (error) {
                console.error("Error al cargar la unidad desde URL:", error);
                await this.handleUnitNotFound(unitId);
            }
        }
    },

    /**
     * Manejar caso cuando la unidad no se encuentra (404 o no existe en el edificio)
     */
    async handleUnitNotFound(unitId, unitData = null) {
        // Limpiar el unit_id de la URL ya que no es válido
        this.updateUrlUnit(null);

        // Obtener unidades del tamaño/tipología seleccionada actualmente
        if (!this.allGroupedUnits[this.activeTab] || Object.keys(this.allGroupedUnits[this.activeTab]).length === 0) {
            try {
                await this.fetchModels(this.activeTab);
            } catch (e) {
                console.error("Error fetching models for fallback:", e);
            }
        }

        const currentSlugModels = this.allGroupedUnits[this.activeTab] || {};
        let unitsFromCurrentTab = [];

        // Extraer todas las unidades de los modelos del tab activo
        for (const [modelName, modelData] of Object.entries(currentSlugModels)) {
            if (modelData.unidades) {
                unitsFromCurrentTab = unitsFromCurrentTab.concat(modelData.unidades);
            }
        }

        const available = unitsFromCurrentTab.filter(u => [8, 9, 12].includes(u.estado_vacios));
        const unavailable = unitsFromCurrentTab.filter(u => ![8, 9, 12].includes(u.estado_vacios));

        // Buscar si la unidad está en las no disponibles para obtener su información
        const foundInUnavailable = unavailable.find(u => u.id === unitId);

        // Determinar la información de la unidad
        let unitName = unitData?.unidad || unitData?.nombre || `Unidad ${unitId}`;
        let reason = 'not_found';
        let unitBathrooms = null;
        let unitM2 = null;
        let unitM2Terrace = null;
        let unitFloor = null;

        if (foundInUnavailable) {
            unitName = foundInUnavailable.unidad || foundInUnavailable.nombre || unitName;
            unitBathrooms = foundInUnavailable.typology?.bathrooms || foundInUnavailable.bathrooms || null;
            unitM2 = foundInUnavailable.m2_utiles || null;
            unitM2Terrace = foundInUnavailable.m2_terraza || 0;
            unitFloor = foundInUnavailable.piso || null;
            reason = 'not_available';
        }

        // Obtener label de la tipología actual
        const currentTabLabel = this.labels[this.activeTab] || this.activeTab;

        this.notFoundUnitData = {
            unitId: unitId,
            unitName: unitName,
            unitBathrooms: unitBathrooms,
            unitM2: unitM2,
            unitM2Terrace: unitM2Terrace,
            unitFloor: unitFloor,
            reason: reason,
            availableUnits: available,
            unavailableUnits: unavailable,
            buildingName: this.building.name,
            buildingPhoto: this.building.photos?.[0] || '/img/image/edificio.png',
            typologyLabel: currentTabLabel
        };

        this.openDrawerUnitNotFound = true;
    },

    /**
     * Manejar caso cuando la unidad existe pero no está disponible
     */
    async handleUnitNotAvailable(unit, modelData, modelInfo, available, unavailable) {
        this.isLoadingUnits = false;

        this.notFoundUnitData = {
            unitId: unit.id,
            unitName: unit.unidad || unit.nombre,
            reason: 'not_available',
            modelName: modelInfo.title,
            modelImg: modelInfo.img,
            availableUnits: available,
            unavailableUnits: unavailable,
            buildingName: this.building.name,
            buildingPhoto: this.building.photos?.[0] || '/img/image/edificio.png',
            typologyBedrooms: modelData?.plano_typology?.bedrooms || null
        };

        this.openDrawerUnitNotFound = true;
    },

    /**
     * Cerrar el drawer de unidad no encontrada
     */
    closeDrawerUnitNotFound() {
        this.openDrawerUnitNotFound = false;
        this.notFoundUnitData = null;
    },

    /**
     * Seleccionar una unidad desde el drawer de no encontrada
     */
    selectUnitFromNotFound(unit) {
        this.closeDrawerUnitNotFound();

        // Actualizar URL con la nueva unidad
        this.updateUrlUnit(unit.id);

        // Recargar con la nueva unidad
        this.$nextTick(() => {
            this.checkUrlForUnit();
        });
    },

    updateCurrentGroups(slug) {
        const tab = this.tabs.find(t => t.slug === slug); 
        if (!tab) {
            this.currentGroups = {};
            return;
        } 
        this.currentGroups = this.allGroupedUnits[slug] ?? {};
    },
    
    updateCurrentModels(slug) {
        this.currentModels = this.allGroupedUnits[slug] ?? {};
        
        // Procesar modelos con su información asegurando que usemos el nombre del modelo contenido en la data
        this.processedModels = Object.entries(this.currentModels).map(([key, modelData]) => {
            const modelName = modelData.nombre || key;
            const modelId = modelData.id_plano || modelData.id || key;
            return {
                id: modelId,
                name: modelName,
                data: modelData,
                info: this.getModelInfo(modelName, modelData)
            };
        });
         
    },
    
    getModelInfo(modelName, modelData) {
        const unidades = modelData.unidades || [];
        const availableUnits = unidades.filter(unit => [8, 9, 12].includes(unit.estado_vacios)).length;
        const availabilityForCoordinateVisit = unidades.filter(unit => [8].includes(unit.estado_vacios)).length;

        // Obtener el precio más bajo de las unidades disponibles
        const prices = unidades
            .filter(unit => [8, 9, 12].includes(unit.estado_vacios) && unit.price)
            .map(unit => parseFloat(unit.price.monto_depto));
        
        const minPrice = prices.length > 0 ? Math.min(...prices) : 0;
        
        // Construir título del modelo usando el nombre real de la data
        const tipologia = modelData.plano_typology || modelData.typology;
        if (!tipologia) return { title: modelName, availability: 0 };

        const banios = (modelData.id_plano || modelData.plano_table_tipologias_id) ? `${tipologia.bathrooms} ${tipologia.bathrooms === 1 ? 'baño' : 'baños'}` : null;

        // Obtener m² promedio
        const m2 = unidades.length > 0 ? parseFloat(unidades[0].m2_utiles || 0) : 0;
        const m2Text = m2 > 0 ? `${Math.round(m2)} m²` : '';
        
        // Verificar si tiene terraza
        const hasTerraza = unidades.some(unit => parseFloat(unit.m2_terraza || 0) > 0);
        const terrazaText = hasTerraza ? 'Terraza' : '';
        
        // CONSTRUYO EL TÍTULO CON EL NOMBRE REAL DEL MODELO
        const nameToUse = modelData.nombre || modelName;
        const titleParts = [
            `${nameToUse}`,
            banios,
            m2Text,
            terrazaText
        ].filter(Boolean);
        
        const benefitsPromo = modelData.benefits_promo ?? null;
        const result = {
            title: titleParts.join(' · '),
            availability: availableUnits,
            availabilityForCoordinateVisit: availabilityForCoordinateVisit,
            price: minPrice > 0 ? `${this.formatPrice(minPrice)}` : '',
            badge: this.getModelBadge(modelData),
            img: modelData.plano_url_imagen || '/img/anuncio/sin-modelo.svg',
            bedrooms: tipologia.bedrooms,
            super_promo: modelData.super_promo ?? false,
            benefits_promo: benefitsPromo,
            has_any_promo_benefit: benefitsPromo
                ? Object.values(benefitsPromo).filter(b => b.show).length > 1
                : false,
        };
        
        return result;
    },
    
    getModelBadge(modelData) {
        const unidades = modelData.unidades || [];
        const hasDiscount = unidades.some(unit => 
            unit.price && parseFloat(unit.price.porcentaje_descuento) > 0
        );
        
        return hasDiscount ? 'Meses OFF' : null;
    },  

    async openModelDrawer(model) {
        // Feedback visual inmediato
        this.isNavigating = true;

        // Resetear el estado del drawer al abrir
        this.step = 'list';
        this.history = [];
        this.selectedUnit = null;

        const idPlano = model.data.id_plano ? model.data.id_plano : model.data.plano_table_tipologias_id;
        const hasIdPlano = !!model.data.id_plano;

        this.selectedModel = {
            name: model.info.title, 
            img: model.info.img, 
            id_plano: idPlano,
            has_id_plano: hasIdPlano,
            units: [],
            availableUnits: 0 
        };

        this.isLoadingUnits = true;
        this.openDrawerUnits = true;

        try {
            let url = `/arriendo/departamento/buildings/${this.building.id}/units?`;
            if (model.data.id_plano) {
                url += `plano_id=${model.data.id_plano}`;
            } else {
                url += `typology_id=${model.data.plano_table_tipologias_id}`;
            }

            const response = await fetch(url);
            if (!response.ok) throw new Error('Error en la carga');

            const freshUnits = await response.json();

            // Filtrar las unidades frescas usando los filtros aplicados
            const filteredFreshUnits = freshUnits.filter(u => this.unitMatchesFilters(u));
            const available = filteredFreshUnits.filter(u => u.is_visitable);
            const unavailable = filteredFreshUnits.filter(u => !u.is_visitable);

            // Actualizamos el modelo con data fresca de la base de datos
            this.selectedModel.units = filteredFreshUnits;
            this.selectedModel.availableUnitsList = available;
            this.selectedModel.unavailableUnitsList = unavailable;
            this.selectedModel.availableUnits = available.length;

            if (this.selectedModel.availableUnits === 0) {
                console.warn('No hay unidades disponibles para este modelo.');
            }

        } catch (error) {
            console.error("No se pudo actualizar la disponibilidad:", error);
        } finally {
            this.isLoadingUnits = false;
            this.isNavigating = false;

            if (globalThis.assetplanAnalytics) {
                globalThis.assetplanAnalytics.for('sitio_web').track('model_select', {
                    building: this.building.name
                });
            }
        }
    },

    getOrientationText(orientacion) { ;
        const orientationKey = orientacion; 
       
        if (!orientationKey) {
            return 'Consultar';
        } 
        
        const translatedText = this.orientationsMap[orientationKey.toUpperCase()]; 
    
        return translatedText ?? orientationKey;
    },

    async getUnit(unit){
        // Asignar inmediatamente los datos que ya tenemos para evitar el parpadeo de datos vacíos
        this.selectedUnit = unit;
        this.isLoadingUnitDetail = true;

        const fullUnit = await this.fetchUnitById(unit.id);
        if (fullUnit) {
            this.selectedUnit = fullUnit;
        }

        this.isLoadingUnitDetail = false;

        // Agregar haptic feedback visual inmediato
        if (navigator.vibrate) {
            navigator.vibrate(50); // Vibración suave en dispositivos móviles
        }

        // Esto maneja el caso donde se selecciona una unidad antes de navegar a detail
        if (this.openDrawerUnits) {
            this.$nextTick(() => {
                this.updateUrlUnit(unit.id);
            });
        }
    },
   
    async refreshModelUnits(showLoading = false) {
        if (!this.selectedModel || !this.selectedModel.id_plano) return;

        if (showLoading) this.isLoadingUnits = true;

        try {
            let url = `/arriendo/departamento/buildings/${this.building.id}/units?`;
            
            if (this.selectedModel.has_id_plano) {
                url += `plano_id=${this.selectedModel.id_plano}`;
            } else {
                url += `typology_id=${this.selectedModel.id_plano}`;
            }

            const response = await fetch(url);
            if (response.ok) {
                const freshUnits = await response.json();
                const filteredFreshUnits = freshUnits.filter(u => this.unitMatchesFilters(u));

                this.selectedModel.units = filteredFreshUnits;
                this.selectedModel.availableUnitsList = filteredFreshUnits.filter(u => u.is_visitable);
                this.selectedModel.unavailableUnitsList = filteredFreshUnits.filter(u => !u.is_visitable);
                this.selectedModel.availableUnits = this.selectedModel.availableUnitsList.length;
            }
        } catch (error) {
            console.error("Error al refrescar unidades:", error);
        } finally {
            if (showLoading) this.isLoadingUnits = false;
        }
    },

    isActive(slug) {
        return this.activeTab === slug;
    },
    
    formatPrice(value) {
        const number = value ?? 0;
        return new Intl.NumberFormat("es-CL", {currency: 'CLP', style: 'currency'}).format(number);
    },

    formatPorcentage(value) { 
        value = Math.round(value);
        return `${value}%`;
    },

    getUnitBadges(unit) {
        if (unit?.ordered_badges) {
            return [
                ...(unit.ordered_badges.promotions ?? []),
                ...(unit.ordered_badges.zone_features ?? []),
            ];
        }
        // Fallback: badges del edificio inyectados desde Blade
        return this.buildingBadges ?? [];
    },

    getBadgeColorClass(color) {
        const colorMap = {
            'gray':           'bg-gray-100 text-gray-600',
            'blue':           'bg-blue-100 text-blue-600',
            'green':          'bg-green-100 text-green-600',
            'red':            'bg-red-100 text-red-600',
            'yellow':         'bg-yellow-100 text-yellow-600',
            'orange':         'bg-orange-100 text-orange-600',
            'purple':         'bg-purple-100 text-purple-600',
            'white':          'bg-white text-gray-800',
            'super-promo':    'text-white bg-magentapromo-700',
            'inverted-green': 'text-green-100 bg-green-600',
            'inverted-blue':  'text-blue-100 bg-blue-600',
        };
        return colorMap[color] ?? colorMap['gray'];
    },

    sortTypologies(tabs) {
        return [...tabs].sort((a, b) => {
            const orderA = this.typologyOrder.indexOf(a.slug);
            const orderB = this.typologyOrder.indexOf(b.slug); 
         
            return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
        });
    }, 
    
    scrollToSection(id) {
        this.active = id;
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } 
    },
    
    handleScroll() {
        for (let tab of this.tabs) {
            const section = document.getElementById(tab.id);
            if (!section) continue;

            const rect = section.getBoundingClientRect();
            if (rect.top <= 100 && rect.bottom >= 100) {
                this.active = tab.id;
            }
        }
    },

    formatDistance(meters) {
        if (!meters) return '';
        if (meters < 1000) {
            return `${Math.round(meters)} metros`;
        }
        return `${(meters / 1000).toFixed(1)} km`;
    },

    formatWalkingTime(meters) {
        // Velocidad promedio de caminata: 80 metros por minuto
        const minutes = Math.round(meters / 80);
        return `${minutes} minuto${minutes !== 1 ? 's' : ''} caminando`;
    },

    translateType(type, count = 1) {
        const translations = {
            // Transporte
            'metro_station': count === 1 ? 'estación de Metro' : 'estaciones de Metro',
            'subway_station': count === 1 ? 'estación de Metro' : 'estaciones de Metro',
            'bus_stop': count === 1 ? 'paradero' : 'paraderos',
            'transit_station': count === 1 ? 'estación de transporte' : 'estaciones de transporte',
            'bus_station': count === 1 ? 'terminal de buses' : 'terminales de buses',
            'train_station': count === 1 ? 'estación de tren' : 'estaciones de tren',

            // Educación
            'university': count === 1 ? 'universidad' : 'universidades',
            'school': count === 1 ? 'colegio' : 'colegios',
            'secondary_school': count === 1 ? 'liceo' : 'liceos',
            'primary_school': count === 1 ? 'escuela' : 'escuelas',
            'kindergarten': count === 1 ? 'jardín infantil' : 'jardines infantiles',
            'preschool': count === 1 ? 'jardín' : 'jardines',

            // Salud
            'hospital': count === 1 ? 'hospital' : 'hospitales',
            'clinic': count === 1 ? 'clínica' : 'clínicas',
            'doctor': count === 1 ? 'centro médico' : 'centros médicos',
            'pharmacy': count === 1 ? 'farmacia' : 'farmacias',
            'health_center': count === 1 ? 'centro de salud' : 'centros de salud',
            'veterinary_care': count === 1 ? 'veterinaria' : 'veterinarias',
            'dentist': count === 1 ? 'dentista' : 'dentistas',
        };

        return translations[type] || type;
    },

    groupPlacesByType(places) {
        if (!places || places.length === 0) return {};

        const grouped = {};
        places.forEach(place => {
            const type = place.type || place.category || 'Otro';
            if (!grouped[type]) {
                grouped[type] = [];
            }
            grouped[type].push(place);
        });

        return grouped;
    },

    /**
     * Cargar filtros desde la URL
     */
    loadFiltersFromUrl() {
        const params = new URLSearchParams(window.location.search);

        // Cargar bedrooms
        const bedrooms = params.get('bedrooms');
        if (bedrooms) {
            this.appliedFilters.bedrooms = bedrooms.split(',').map(b => parseInt(b));
        }

        // Cargar bathrooms
        const bathrooms = params.get('bathrooms');
        if (bathrooms) {
            this.appliedFilters.bathrooms = bathrooms.split(',').map(b => parseInt(b));
        }

        // Cargar min_price
        const minPrice = params.get('min_price');
        if (minPrice) {
            this.appliedFilters.min_price = parseInt(minPrice);
        }

        // Cargar max_price
        const maxPrice = params.get('max_price');
        if (maxPrice) {
            this.appliedFilters.max_price = parseInt(maxPrice);
        }
    },

    /**
     * Verificar si una unidad cumple con los filtros
     */
    unitMatchesFilters(unit) {
        // Filtro de dormitorios
        if (this.appliedFilters.bedrooms.length > 0) {
            const unitBedrooms = this.getUnitBedrooms(unit);
            if (!this.appliedFilters.bedrooms.includes(unitBedrooms)) {
                return false;
            }
        }

        // Filtro de baños
        if (this.appliedFilters.bathrooms.length > 0) {
            const unitBathrooms = this.getUnitBathrooms(unit);
            if (!this.appliedFilters.bathrooms.includes(unitBathrooms)) {
                return false;
            }
        }

        // Filtro de precio mínimo
        if (this.appliedFilters.min_price !== null) {
            const unitPrice = this.getUnitPrice(unit);
            if (unitPrice < this.appliedFilters.min_price) {
                return false;
            }
        }

        // Filtro de precio máximo
        if (this.appliedFilters.max_price !== null) {
            const unitPrice = this.getUnitPrice(unit);
            if (unitPrice > this.appliedFilters.max_price) {
                return false;
            }
        }

        return true;
    },

    /**
     * Obtener el número de dormitorios de una unidad
     */
    getUnitBedrooms(unit) {
        // Soporte para estructura API
        if (unit.typology && unit.typology.bedrooms !== undefined) {
            return unit.typology.bedrooms;
        }

        // El tipo de unidad indica los dormitorios
        const tipo = unit.tipo?.toLowerCase() || '';
        if (tipo.includes('estudio')) return 0;
        if (tipo.includes('1 dormitorio')) return 1;
        if (tipo.includes('2 dormitorio')) return 2;
        if (tipo.includes('3 dormitorio')) return 3;
        if (tipo.includes('4 dormitorio') || tipo.includes('4+') || tipo.includes('4 o más')) return 4;

        // Intentar extraer número del tipo
        const match = tipo.match(/(\d+)/);
        return match ? parseInt(match[1]) : 0;
    },

    /**
     * Obtener el número de baños de una unidad
     */
    getUnitBathrooms(unit) {
        // Soporte para estructura API
        if (unit.typology && unit.typology.bathrooms !== undefined) {
            return unit.typology.bathrooms;
        }

        // Buscar en planos o en la unidad directamente
        return unit.planos?.[0]?.bathrooms || unit.bathrooms || 1;
    },

    /**
     * Obtener el precio de una unidad
     */
    getUnitPrice(unit) {
        // Soporte para estructura API donde price es un objeto
        if (unit.price && typeof unit.price === 'object' && unit.price.monto_depto) {
            return unit.price.monto_depto;
        }
        return unit.price?.monto_depto || unit.price || 0;
    },

    /**
     * Obtener texto descriptivo de los filtros aplicados
     */
    getFiltersText() {
        const parts = [];

        if (this.appliedFilters.bedrooms.length > 0) {
            const bedroomText = this.appliedFilters.bedrooms.sort((a,b) => a - b).join(', ');
            parts.push(`${bedroomText} dormitorios`);
        }

        if (this.appliedFilters.bathrooms.length > 0) {
            const bathroomText = this.appliedFilters.bathrooms.sort((a,b) => a - b).join(', ');
            parts.push(`${bathroomText} baños`);
        }

        if (this.appliedFilters.min_price || this.appliedFilters.max_price) {
            let priceText = 'Precio: ';
            if (this.appliedFilters.min_price && this.appliedFilters.max_price) {
                priceText += `${this.formatPrice(this.appliedFilters.min_price)} - ${this.formatPrice(this.appliedFilters.max_price)}`;
            } else if (this.appliedFilters.min_price) {
                priceText += `desde ${this.formatPrice(this.appliedFilters.min_price)}`;
            } else {
                priceText += `hasta ${this.formatPrice(this.appliedFilters.max_price)}`;
            }
            parts.push(priceText);
        }

        return parts.join(' • ');
    },

    async notifyMe(){

        if (!this.email) {
            this.errorMessage = 'El correo es obligatorio';
            return;
        }

        this.loading_notify = true;
        this.errorMessage = '';

        try {  
            const url = `${this.apiUrl}subscriptions/schedule`;
            const payload = {
                email: this.email,
                property_id: this.selectedUnit.id
            }

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Api-Token': import.meta.env.VITE_API_TOKEN, 
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
 
            if (!response.ok) {
               throw new Error(data.message || 'Error al procesar la solicitud');
            } 
            
            this.notified = true; 
            this.triggerToast('Te avisaremos cuando haya disponibilidad', 'success'); 
           

        }catch(e){
            this.triggerToast('No pudimos registrar tu correo. Inténtalo nuevamente.', 'error');
        }finally{ 
            //Reiniciamos  
            this.loading_notify = false;  
            this.email = '';
            this.errorMessage = '';  
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.closeDrawer();
        }
    },

    isEmailValid(fieldName) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
        const value = (this[fieldName] || '').trim();
        return emailRegex.test(value);
    }, 

    validateField(fieldName, errorVarName = 'errorMessage') { 
        const value = fieldName.split('.').reduce((obj, key) => obj?.[key], this)?.toString().trim() || '';
     
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let message = '';

        if(fieldName.includes('phone')){
            const phoneRegex = /^[0-9]+$/;
            if (value.length === 0) {
                message = 'El campo es obligatorio.';
            } else if (!phoneRegex.test(value)) {
                message = 'El teléfono solo puede contener números.';
            }
            else if(value.length < 7) {
                message = 'El número de teléfono debe tener al menos 7 dígitos.';
            } else if(value.length > 15) {
                message = 'El número de teléfono debe tener como máximo 15 dígitos.';
            }
            this.setErrorMessage(errorVarName, message);
            return;
        }

        if (fieldName.includes('reason') && this.hasBroker) {
            this.setErrorMessage(errorVarName, '');
            return;
        }

        if (value.length === 0) {
            message = 'El campo es obligatorio.';
        } else if (fieldName.toLowerCase().includes('email')) {
            message = emailRegex.test(value) ? '' : 'Por favor, ingresa un correo válido.';
        }else if(fieldName.toLowerCase().includes('terms')){
            message = value === 'true' ? '' : 'Debes aceptar los términos y condiciones.';
        } else {
            message = '';
        }

        
        this.setErrorMessage(errorVarName, message);
    },

    setErrorMessage(errorVarName, message) {
        const parts = errorVarName.split('.');
        let target = this;
        for (let i = 0; i < parts.length - 1; i++) {
            target = target[parts[i]];
        }
        target[parts[parts.length - 1]] = message;
    },

    triggerToast(message, type) {
        this.toast.message = message;
        this.toast.type = type;
        this.toast.show = true;

        setTimeout(() => {
            this.toast.show = false;
        }, 5000);
    },

    showDrawerAvailable(model){  
        this.modelNoAvailable = {
            bedrooms:model.info.bedrooms,
            table_tipologia_id:model.data.plano_table_tipologias_id,
        };
        this.openDrawerAvailable = true;
    },

    closeModelDrawer() {
        this.openDrawerAvailable = false;
        this.email_model_no_available = '';
        this.errorMessageNoAvailable = '';
    },

    async notifyMeModelNoAvailable() {

        if (!this.email_model_no_available) {
            this.errorMessage = 'El correo es obligatorio';
            return;
        }

        this.loading_notify = true;
        this.errorMessage = '';

        try {

            const url = `${this.apiUrl}subscriptions`;

            const payload = {
                email: this.email_model_no_available,
                property_group_id: this.building.id,
                table_tipologia_id: [this.modelNoAvailable.table_tipologia_id]
            }

            const response = await fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Api-Token': import.meta.env.VITE_API_TOKEN, 
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if(response.ok){
                this.triggerToast('¡Te avisaremos apenas haya disponibilidad!', 'success'); 
            }else{
                throw new Error(data.message || 'No se pudo procesar la solicitud');
            }

        } catch (error) {
            this.triggerToast('No pudimos registrar tu correo. Inténtalo nuevamente.', 'error');
        }finally {
            this.email_model_no_available = ''; 
            this.openDrawerAvailable = false;
        }
    },

    toCoordinateVisitFromUnit() { 
        const unitId = this.selectedUnit.id;
        const typologySlug = this.slug(this.selectedUnit.tipo) || this.activeTab;
        
        const url = `${globalThis.location.origin}/coordinar-visita/${unitId}/${this.building.id}/${typologySlug}?from=1`;

        if(globalThis.assetplanAnalytics){
            globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:start_button_click', {
                building_type: this.building.multifamily ? 'multifamily' : 'retail',
                property_state: this.selectedUnit.estado_vacios === 8 ? 'available' : 'not_available',
                from: 'unit'
            })
        }
   
        globalThis.location.href = url;
    },

    toCoordinateVisitFromBuilding() {
        let unit = this.getUnitMoreCheap();

        if (unit?.id) {
            const url = `${globalThis.location.origin}/coordinar-visita/${unit.id}/${this.building.id}/${this.activeTab}?from=4`;

            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:start_button_click', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                    property_state: unit.estado_vacios === 8 ? 'available' : 'not_available',
                    from: 'landing'
                })
            }

            globalThis.location.href = url;
        } else {
           this.showDrawerAvailable(this.processedModels[0]);
        }
    },

    getUnitMoreCheap(){
        let unit_select = null;
        let minPrice = null;

        const models = this.processedModels;

        models.forEach(model => {
            if (model.info.availability > 0) {
                (model.data.unidades || []).forEach(unit => {
                    if (unit.is_available && [8].includes(unit.estado_vacios)) {
                        const price = this.getUnitPrice(unit);
                         
                        if (price > 0 && (minPrice === null || price < minPrice)) {
                            minPrice = price;
                            unit_select = unit;
                        }
                    }
                });
            }
        });
        
        return unit_select;
    },

    get hasAvailabilityInTab() {
        return this.processedModels.some(model => model.info.availabilityForCoordinateVisit > 0);
    },

    get hasAvailabilityPrice() {
        return this.processedModels.some(model => model.info.availability > 0);
    },

    /**
     * Indica si el edificio tiene disponibilidad en ALGUNA tipología (todos los tabs).
     * Usa building.available_typologies_tabs que se carga al inicio con min_price > 0
     * cuando existe al menos una unidad disponible en ese tab.
     */
    get hasAvailabilityInBuilding() {
        return this.tabs.some(tab => tab.min_price > 0);
    },

    startWhatsapp(unit=null) {
        if(globalThis.assetplanAnalytics){
            globalThis.assetplanAnalytics.for('sitio_web').track('action_start', {
                action_type: 'whatsapp',
                from: unit ? 'unit' : 'landing'
            })
        }

        const num = this.epcWhatsappFromTwo || '';
        let phoneNumber = num
            .replace('+', '').replace('-', '').replace(' ', '')
            .replace(':', '').replace('whatsapp', '');

        let unit_selected = unit;
        let refUrl = `${globalThis.location.origin}${globalThis.location.pathname}`;

        let code = this.activeTab === 'estudio' ? 'ESTUDIO' : this.activeTab.split('-')[0].toUpperCase() + 'D';
        let mensaje = `¡Hola, me interesa una unidad del edificio ${this.building.name} [COD: ${this.building.id}-${code}]`;

        if(unit_selected){
            refUrl += `?unit_id=${unit_selected?.id}`;
            mensaje = `¡Hola!, tengo algunas preguntas sobre ${this.building.name}, ${refUrl}`;
        }

        whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(mensaje)}`;
        
        globalThis.location.href = whatsappUrl;
    },

    async toContactMe(){ 
        this.loading_form_contactme = true;
        this.showContactMeModal = true;
        if(globalThis.assetplanAnalytics){
            globalThis.assetplanAnalytics.for('sitio_web').track('action_start', {
                action_type: 'contact_me',
                from: 'landing',
                ab_boton_qqmc: this.ctaBotonQqmcVariant,
            })
        }

        await this.fetchContactmeController();
    },

    async fetchContactmeController(){
        try {
            let url = `${globalThis.location.origin}/arriendo/departamento/contactme/${this.building.id}/${this.refer_code || ''}`;
            const response = await fetch(url);

            if(response.ok){
                const data = await response.json(); 
                this.hasBroker = data.hasbroker; 
            }else{
                throw new Error(data.message || 'No se pudo procesar la solicitud');
            } 
        
        } catch (error) {
            this.triggerToast(error.message, 'error'); 
        }finally{
            this.loading_form_contactme = false;
        }
    },

    closeContactMeModal(){
        this.showContactMeModal = false; 
        this.sendingContactForm = false;
        this.formDataContactme = {
            name: '',
            last_name: '',
            email: '',
            phone: '',
            reason: ''
        };
        this.errors = {
            name: '',
            last_name: '',
            rut: '',
            email: '',
            phone: '',
            terms: '',
            reason: ''
        };
    },

    async submitContactForm(){
        this.sendingContactForm = true
        let unit = this.getUnitMoreCheap();

        try { 
            let url = `${globalThis.location.origin}/arriendo/departamento/contactme`;

            this.formDataContactme.unit_id = unit.id;
            const payload =  this.formDataContactme;
            
            const response = await fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    'Accept': 'application/json', 
                },
                body: JSON.stringify(payload)
            }); 
            
            const data = await response.json();

            if(response.ok){
                if(globalThis.assetplanAnalytics){
                    globalThis.assetplanAnalytics.for('sitio_web').track('contact_form_submit')
                }

                if(data.data_layer_event){
                    globalThis.dispatchEvent(new CustomEvent('sendDataLayerCustomEvent', {
                        detail: {
                            name: data.data_layer_event.name,
                            payload: {
                                email: this.formDataContactme.email,
                                telefono: this.formDataContactme.phone,
                                comentario: this.formDataContactme.reason,
                                edificio: this.building['name'],
                                dormitorios: unit?.typology?.bedrooms > 1 ? `${unit.typology.bedrooms} dormitorios` :  `${unit.typology.bedrooms} dormitorio`,
                                comuna: this.building['commune'],
                                tipologia: unit?.typology?.id,
                                price: unit.price.monto_depto
                            }
                        }
                    }));
                }

                if (this.openDrawerUnits) {
                    this.resetForm();
                    await this.fetchSimilarBuildings();
                    this.goTo('schedule_success');
                } else {
                    this.triggerToast('Listo. Te contactaremos dentro de 48hrs.', 'success');
                    this.showContactMeModal = false;
                    this.resetForm();
                }
            }else{
                throw new Error(data.message || 'No se pudo procesar la solicitud');
            }  

        } catch (error) {
            this.triggerToast(error.message, 'error'); 
        }finally{
            this.sendingContactForm = false;
        } 
    },

    resetForm(){
        this.formDataContactme = {
        ...this.formDataContactme,
        name: '',
        last_name: '',
        email: '',
        phone: '',
        reason: '',
        terms: false
    };

        this.errors = {
            name: '',
            last_name: '',
            rut: '',
            email: '',
            phone: '',
            terms: '',
            reason: ''
        };

        // Limpiar estado del calendario interno al cerrar el drawer.
        // Esto evita que una selección anterior contamine un intento nuevo.
        this.scheduleVisitCalendar.resetTimeSlots();
    },

    get canSubmit() { 
        const hasErrors = this.errors.name || this.errors.last_name || this.errors.email || this.errors.phone || this.errors.terms || (this.errors.reason && !this.toBroker); 
        
        const isFormEmpty = !this.formDataContactme.name || !this.formDataContactme.email || !this.formDataContactme.phone || !this.formDataContactme.terms || (!this.formDataContactme.reason && this.toBroker);

        return !hasErrors && !isFormEmpty;
    }
    
});
